class CatalogError extends Error {
  constructor(cause, url, props, code = 'CATALOG_ERROR') {
    super("Falha ao obter dados do catálogo");
    this.name = 'CatalogError';
    this.code = code;
    this.cause = cause;
    this.url = url;
    this.props = props;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CatalogError);
    }
  }
}

module.exports = CatalogError;